import { createSlice } from "@reduxjs/toolkit";

const destinationSlice = createSlice({
  name: "destination",
  initialState: {
    data: [],
  },
  reducers: {
    addDestination: (state, action) => {
      state.data.push(action.payload);
    },
    updateDestination: (state, action) => {
      const { index, updatedData } = action.payload;
      state.data[index] = updatedData;
    },
    deleteDestination: (state, action) => {
      state.data.splice(action.payload, 1);
    },
  },
});

export const { addDestination, updateDestination, deleteDestination } = destinationSlice.actions;
export default destinationSlice.reducer;
